import { atom } from 'recoil';

export const project = atom({
    key: 'project',
    default: {
        'kickey': {
            'name': 'Kickey',
            'position': 'Co-founder',
            'description': 'Platform for indie game publishing and copyright game rental on Steam/Origin/Ubisoft',
            'logo': 'https://kickey.net/static/images/logo.png',
            'link': {
                'text': 'View website',
                'url': 'https://kickey.net'
            },
            'date': 'December 2020',
            'service': 'Gaming platform',
            'type': 'Service',
            'overview': {
                'description': 'Use right on the website without downloading. Simple operation, and constantly updating to meet user needs',
                'image': [
                    'https://kickey.net/_next/image?url=%2Fstatic%2Fimages%2Fzzw2.png&w=3840&q=75',
                ]
            },
            'result': {
                'description': 'Statistics are at the end of 2021',
                'list': [
                    'Topping the search results related to the keyword game rental on Google',
                    'Over 300 games on Steam, Origin and Ubisoft platforms',
                    'More than 28,000 people register for an account'
                ]
            }
        },
        'seedstage': {
            'name': 'SeedStage',
            'position': 'Founder',
            'description': 'SeedStage is a hybrid super-platform revolutionizing the Vietnamese startup ecosystem with its \'Fund, Own, Trade\' philosophy. It bridges reward crowdfunding and equity investment, enabling users to fund projects, own shares via SPV structures, and trade assets on a secondary marketplace to ensure liquidity throughout the startup lifecycle',
            'logo': '../static/image/seestage.png',
            'link': {
                'text': 'View website',
                'url': 'https://seedstage.vn'
            },
            'date': 'January 2026',
            'service': 'Financial service',
            'type': 'Service'
        },
        'bandeck': {
            'name': 'Bandeck',
            'position': 'Founder',
            'description': 'The content delivery network and proxy service for Google Drive',
            'logo': '../static/image/bandeck.png',
            'link': {
                'text': 'View website',
                'url': 'https://bandeck.com'
            },
            'date': 'October 2021',
            'service': 'Cloud storage',
            'type': 'Service'
        },
        'memfy': {
            'key': 'memfy',
            'name': 'Memfy',
            'position': 'Author',
            'description': 'Lightweight real-time memory management application to monitor and clean system memory on your computer',
            'logo': '../static/image/memfy.png',
            'link': {
                'text': 'Download now',
                'url': 'https://duyanh.me/static/file/MemfySetup.exe'
            },
            'date': 'August 2021',
            'service': 'Computer optimize',
            'type': 'Software',
            'overview': {
                'description': 'The program used undocumented internal system features (Native API) to clear system cache (system working set, working set, standby page lists, modified page lists) with variable result ~10-50%. Application it is compatible with Windows 7 or higher',
                'image': [
                    'https://duyanh.me/static/image/memfy_thub.jpg',
                ]
            },
        }
    },
});
